import 'jquery-zoom';

const viewport = $(window).width();

if (viewport > 576) {
  $('#slick-product .zoom-wp').each((_, elm) => {
    $(elm).zoom();
  });
}
